export const SITE_URL = 'https://e-invitation.online';
export const SITE_NAME = 'E-Invitation by Logica Technology';
export const DEFAULT_TITLE = `${SITE_NAME} | Digital Invitations Philippines`;
export const DEFAULT_DESCRIPTION =
  'Create SEO-ready digital invitations in the Philippines for weddings, birthdays, christenings, corporate events, and anniversaries. Standard package starts at \u20b1800 with RSVP, mobile sharing, and fast delivery.';
export const DEFAULT_KEYWORDS =
  'digital invitation Philippines, e-invitation Philippines, wedding digital invitation, birthday digital invitation, christening invitation, RSVP invitation website, online invitation Philippines, Logica Technology, e-invite';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/favicon.png`;

export const ORGANIZATION_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: SITE_NAME,
  description:
    'SEO-ready digital invitation design service for weddings, birthdays, christenings, corporate events, and anniversaries in the Philippines.',
  url: SITE_URL,
  logo: DEFAULT_OG_IMAGE,
  image: DEFAULT_OG_IMAGE,
  email: 'sales@logicatechnology.com',
  sameAs: [
    'https://www.facebook.com/profile.php?id=61585468153192',
    'https://www.tiktok.com/@logicatechnology',
    'https://logicatechnology.com',
  ],
  priceRange: '\u20b1800+',
  currenciesAccepted: 'PHP',
  areaServed: 'Philippines',
  serviceType: 'Digital Invitation Design',
  makesOffer: {
    '@type': 'Offer',
    name: 'Standard E-Invitation Package',
    price: '800',
    priceCurrency: 'PHP',
    availability: 'https://schema.org/InStock',
    url: `${SITE_URL}/pricing`,
  },
};
